<template>
  <div class="position-box">
      <div class="head">
        <img class="back" src="@/assets/icon_back.png" @click="goBack" alt="back">
        <div>{{$t('langNew2.zb')}}</div>
        <router-link to="/activityRule" class="rule" tag="div"><img class="icon" src="@/assets/new3/guize.png" alt=""></router-link>
      </div>
      <div class="cont-box">
        <div class="sy-box">
          <div class="sy-foot">
            <div class="foot-lt">
              <div class="t1">{{$t('langNew3.jrlh')}}</div>
              <div class="t2">{{$t('langNew3.sywd')}}</div>
            </div>
            <img class="icon" src="@/assets/new3/picture_4.jpg" alt="">
          </div>
        </div>
        <ul class="ul-box">
          <li class="ul-li">
            <div class="title">{{profit.name}}</div>
            <div class="list-foot">
              <div class="list-item">
                <div class="text">{{$t('langNew.dbxe')}}</div>
                <div class="money">{{moneylimit}}</div>
              </div>
              <div class="list-item">
                <div class="text">{{$t('langNew.syl')}}</div>
                <div class="money">{{profit.rate_win}}%</div>
              </div>
            </div>
            <!-- <div class="tips">{{$t('langNew3.bzbz')}}</div>
            <div class="bz-wrap">
              <div class="bz-box">
                <img v-for="(item,index) in bzData" :key="index" class="img" :src="item.icon" alt="">
              </div>
            </div> -->
            <div class="tips">{{$t('bzhlgm.tgje')}}</div>
            <div class="money-box">
              <input class="money" v-model="money" @keyup="keyMoney()" :placeholder="$t('bzhlgm.dbxe') + moneylimit"
              autocomplete="off" type="text">
              <div class="dw">USDT</div>
            </div>
            <div class="btn-buy" @click="buy">{{$t('bzhlgm.rm')}}</div>
          </li>
        </ul>
      </div>
      <div class="mask" v-show="isShow"></div>
      <div class="alert-pwd-box" v-show="isShow">
          <div class="alert-head">{{$t('usdttb.qsrjymm')}}</div>
          <img class="close" src="@/assets/new3/close.png" @click="close" alt="">
          <ul class="pwd-box">
              <li class="pwd" v-for="(item,index) in inputList" :key="index"><input class="input pwd-input" v-model="item.val" type="password" maxlength="1" oninput = "value=value.replace(/[^\d]/g,'')" @keyup="nextFocus($event,index)" inputmode="numeric" autocomplete="off"></li>
          </ul>
      </div>
  </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
import VueCircle from '@/pages/circle.vue'
let that = this;
export default {
    name: 'loanBuy',
    data () {
        return {
          uid: '',
          token: '',
          lang: 'en',
          isMask: false,
          useBalance: 0,
          totlaMoney: 0,
          amount: 1,
          password: '',
          id: '',
          currency: '',
          bzData: [],
          money: "",
          profit: {},
          moneylimit: "",
          inputList: [
            { val: "" },
            { val: "" },
            { val: "" },
            { val: "" },
            { val: "" },
            { val: "" },
          ],
          isShow: false,
          count: 1
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.id = this.$route.query.id;
      this.lang = localStorage.getItem('user_lang');
      this.token = localStorage.getItem('token');
      this.currency = localStorage.getItem('sbsxbz') || 'USDT';
    },
    mounted() {
      this.getmarketList();
      this.getAsset();
      this.getProfitInfo();
    },
    methods: {
      goBack(){
        this.$router.push('/loan')
      },
      getmarketList(){
        let params = {
            id: 1,
            type: "profit"
        }
        this.$ajax.get('/web/getCurrencyAll',{params}).then((res) => {
            let resData = res.data.data;
            this.bzData = resData.filter(item=>{
              return (item.name != this.currency.toLowerCase())
            });
        }).catch(function(err){
            console.log(err)
        })
      },
      getAsset(){
        let that = this;
        let params = {
          id: 1
        }
        this.$ajax.get('/web/getAsset2',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/index');
              },1000)
              return false
            }
            this.useBalance =  (Number(resData.list.filter(item =>{
              return item.currency == this.currency
            })[0].positions)).toFixed(4);
        }).catch(function(err){
            console.log(err)
        })
      },
      getProfitInfo(){
        let params = {
          id: this.id
        }
        this.$ajax.get('/web/getProfitInfo',{params}).then((res) => {
            let resData = res.data.data;
            this.profit = resData;
            this.moneylimit = resData.moneylimit
        }).catch(function(err){
            console.log(err)
        })
      },
      buy(){
        var limitStart = parseFloat(this.profit.moneylimit.split('-')[0]);
        var limitEnd = parseFloat(this.profit.moneylimit.split('-')[1]);
        if(!this.money || this.money == null){
          this.$toast.center(this.$t('bzhlgm.dbxe') + this.profit.moneylimit);
          return;
        }else if(parseFloat(this.money) < limitStart){
          this.$toast.center(this.$t('bzhlgm.dbxe') + this.profit.moneylimit);
          return;
        }else if(parseFloat(this.money) > limitEnd){
          this.$toast.center(this.$t('bzhlgm.dbxe') + this.profit.moneylimit);
          return;
        }
         let params = {
            profit: this.id,
            amount: this.money,
            tpassword: ''
          }
          if(this.count == 1){
            this.count = 0;
          }else{
              return false;
          }
          this.$ajax.post('/web/buyProfit',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  this.$toast.center(resData.message);
                  setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/orderStatus')
                  }, 1000)
              }else{
                  this.count = 1;
                  this.isShow = false;
                  this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
        // this.isShow = true;
      },
      nextFocus(el,index) {
        var dom = document.getElementsByClassName("pwd-input"),
          currInput = dom[index],
          nextInput = dom[index + 1],
          lastInput = dom[index - 1];
        /*这里的keyCode 根据不同的平台或许不同,安卓就是不是8*/
        if(el.keyCode != 8) {
          if(dom[0].value == ''){
              dom[0].value = this.inputList[0].val = currInput.value;
              currInput.value = this.inputList[index].val ='';
              dom[0].blur();
              dom[1].focus();
          }
          if(currInput.value == '') return;
          if(index < (this.inputList.length - 1)) {
              nextInput.focus();
          }else {
              currInput.blur();
          }
        }else{
            if(index != 0) {
              lastInput.focus();
            }
        }
        let password = this.inputList[0].val +  this.inputList[1].val + this.inputList[2].val + this.inputList[3].val +  this.inputList[4].val + this.inputList[5].val;
        if(password.length == 6){
          let params = {
            profit: this.id,
            amount: this.money,
            tpassword: password
          }
          if(this.count == 1){
            this.count = 0;
          }else{
              return false;
          }
          this.$ajax.post('/web/buyProfit',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  this.$toast.center(resData.message);
                  setTimeout(() => {
                    this.count = 1;
                    this.$router.push('/orderStatus')
                  }, 1000)
              }else{
                  this.count = 1;
                  this.isShow = false;
                  this.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
                  this.$toast.center(resData.message);
                  return;
              }
          }).catch(function(err){
              console.log(err)
          })
        }else{
          return false;
        }
      },
      keyMoney(){
        this.money = this.money.replace(/[^\d.]/g, "");  //仅保留数字和"."
        this.money = this.money.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
        this.money = this.money.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
        this.money = this.money.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
        if (this.money.indexOf(".") < 0 && this.money != "") { //首位是0的话去掉
            this.money = parseFloat(this.money);
        }
      },
      close() {
        this.isShow = false;
        this.inputList = [
          { val: "" },
          { val: "" },
          { val: "" },
          { val: "" },
          { val: "" },
          { val: "" },
        ];
      },
    },
    filters: {
        statusText: (val) => {
            if(val == 0){
                return that.xsh
            }else if(val == 1){
                return ''
            }
        },
        times: function(timestamp){
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        }
    },
    watch: {
        amount: function(val){
            if(val > this.dataDetail.moneylimit){
                this.amount = this.dataDetail.moneylimit;
            }else if(val == ''){
                this.amount = '';
            }else if(val == 0){
                this.amount = 1;
            }else{
                this.amount = val;
            }
        }
    },
    components:{
        navBar,
        noData,
        VueBetterScroll,
        VueCircle
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #C4C4C4;
        font-size: .42rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #000;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        padding: 0 .3rem;
        color: #fff;
        font-size: .56rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        /* background: #fbfbfb; */
        text-align: center;
    }
    .head .back{
      position: absolute;
      left: 0.3rem;
      top: 0.3rem;
      width: .32rem;
      height: .6rem;
    }
    .head .icon{
        position: absolute;
        right: .4rem;
        top: .3rem;
        width: .6rem;
    }
    .head .title{
      padding: .8rem 0 0;
      color: #000;
    }
    .head .money{
      margin-top: .48rem;
      color: #fff;
      font-size: .78rem;
    }
    .cont-box{
        position: absolute;
        left: 0;
        right: 0;
        top: 1.4rem;
        bottom: 0;
        z-index: 999;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        overflow-y: scroll;
    }
    .sy-box{
      padding: .3rem .56rem .3rem .5rem;
      background: rgba(26,36,63,.4);
    }
    .sy-box .sy-head{
      display: flex;
      align-items: stretch;
      border-bottom: 1px solid #e8e8e8;
      padding: .5rem 0;
    }
    .sy-box .sy-head .sy-li{
      width: 50%;
      text-align: center;
    }
    .sy-box .sy-head .sy-li .text{
      height: .9rem;
      color: #3c404b;
      font-size: .46rem;
    }
    .sy-box .sy-head .sy-li .sy{
      margin-top: .5rem;
      color: #3c404b;
      font-size: .46rem;
    }
    .sy-box .sy-foot{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: .2rem 0 .3rem;
    }
    .sy-box .sy-foot .foot-lt .t1{
      color: #fff;
      font-size: .6rem;
    }
    .sy-box .sy-foot .foot-lt .t2{
      padding-top: .4rem;
      color: #fff;
      font-size: .56rem;
    }
    .sy-box .sy-foot .icon{
      width: 3.54rem;
    }
    .tips{
      margin: .6rem 0 .36rem;
      color: #fff;
      font-size: .48rem;
    }
    .ul-box .ul-li{
      margin: .3rem .42rem .3rem .36rem;
      padding: 0 .52rem .35rem;
      background: rgba(26,36,63,.4);
      box-shadow: 0rem 0.1rem 0.2rem 0rem
        rgba(24, 11, 0, 0.09);
      border-radius: 0.28rem;
    }
    .ul-box .ul-li .title{
      padding: .58rem 0;
      color: #fff;
      font-size: .48rem;
      border-bottom: 1px solid #424040;
    }
    .ul-box .ul-li .list-foot{
      display: flex;
      align-items: stretch;
    }
    .ul-box .ul-li .list-item{
      width: 50%;
      padding: .54rem 0;
      text-align: center;
    }
    .ul-box .ul-li .list-item .text{
      color: #fff;
      font-size: .42rem;
      min-height: 1.1rem;
    }
    .ul-box .ul-li .list-item .money{
      margin-top: .4rem;
      color: #fff;
      font-size: .46rem;
    }
    .bz-wrap{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: .4rem;
      border-bottom: 1px solid #e8e8e8;
    }
    .bz-box{
      display: flex;
      align-items: center;
    }
    .bz-box .img{
      width: .7rem;
      margin-right: .3rem;
    }
    .bz-wrap .icon{
      width: 1rem;
      height: 1rem;
    }
    .money-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.36rem;
      padding: .35rem .4rem;
      background: rgba(26,36,63,.4);
      border-radius: 0.21rem;
      box-sizing: border-box;
    }
    .money-box .money{
      color: #fff;
      font-size: .48rem;
    }
    .money-box .money .dw{
      color: #fff;
      font-size: .48rem;
    }
    .btn-buy{
      height: 1.4rem;
      margin: .8rem .4rem;
      color: #fff;
      font-size: .56rem;
      line-height: 1.4rem;
      background-color: #588bf8;
      border-radius: 0.28rem;
      text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/loanBuy.vue